import { createSelector } from '@reduxjs/toolkit';

import { DELETE_CLASS_MODAL_STAGES } from '@classCreation/data/deleteClassModalStages';

const baseSelector = (state) => state.deleteSbatGroup;

export const modalStageSelector = (state) => baseSelector(state).modalStage;

export const deleteSbatGroupCommunicationsSelector = (state) =>
  baseSelector(state).communications;

export const isModalOpenSelector = createSelector(
  modalStageSelector,
  (modalStage) => modalStage !== DELETE_CLASS_MODAL_STAGES.notOpen
);

export const selectedDeleteSbatGroupSelector = (state) =>
  baseSelector(state).selectedSbatGroup;

export const deleteReasonSelector = (state) => baseSelector(state).deleteReason;

export const deleteSbatGroupErrorMessageSelector = (state) =>
  baseSelector(state).deleteSbatGroupErrorMessage;
